"use client"

import { useState } from "react"
import "./Settings.css"

const Settings = () => {
  const [settings, setSettings] = useState({
    notifications: {
      email: true,
      push: true,
      announcements: true,
      prayerRequests: true,
      messages: true,
    },
    appearance: {
      theme: "light",
      fontSize: "medium",
    },
    security: {
      twoFactor: false,
      sessionTimeout: "30",
    },
  })

  const handleNotificationChange = (setting) => {
    setSettings({
      ...settings,
      notifications: {
        ...settings.notifications,
        [setting]: !settings.notifications[setting],
      },
    })
  }

  const handleAppearanceChange = (setting, value) => {
    setSettings({
      ...settings,
      appearance: {
        ...settings.appearance,
        [setting]: value,
      },
    })
  }

  const handleSecurityChange = (setting, value) => {
    setSettings({
      ...settings,
      security: {
        ...settings.security,
        [setting]: value,
      },
    })
  }

  return (
    <div className="settings-page">
      <h1 className="page-title">Settings</h1>

      <div className="settings-container">
        <div className="settings-section">
          <h2>Notifications</h2>
          <div className="settings-group">
            <div className="setting-item">
              <div className="setting-info">
                <h3>Email Notifications</h3>
                <p>Receive notifications via email</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.email}
                  onChange={() => handleNotificationChange("email")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Push Notifications</h3>
                <p>Receive push notifications in browser</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.push}
                  onChange={() => handleNotificationChange("push")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Announcements</h3>
                <p>Get notified about new announcements</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.announcements}
                  onChange={() => handleNotificationChange("announcements")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Prayer Requests</h3>
                <p>Get notified about new prayer requests</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.prayerRequests}
                  onChange={() => handleNotificationChange("prayerRequests")}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Messages</h3>
                <p>Get notified about new messages</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.notifications.messages}
                  onChange={() => handleNotificationChange("messages")}
                />
                <span className="slider"></span>
              </label>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h2>Appearance</h2>
          <div className="settings-group">
            <div className="setting-item">
              <div className="setting-info">
                <h3>Theme</h3>
                <p>Choose your preferred theme</p>
              </div>
              <select
                className="form-control"
                value={settings.appearance.theme}
                onChange={(e) => handleAppearanceChange("theme", e.target.value)}
              >
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="system">System Default</option>
              </select>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Font Size</h3>
                <p>Adjust the text size</p>
              </div>
              <select
                className="form-control"
                value={settings.appearance.fontSize}
                onChange={(e) => handleAppearanceChange("fontSize", e.target.value)}
              >
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
              </select>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h2>Security</h2>
          <div className="settings-group">
            <div className="setting-item">
              <div className="setting-info">
                <h3>Two-Factor Authentication</h3>
                <p>Add an extra layer of security to your account</p>
              </div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={settings.security.twoFactor}
                  onChange={(e) => handleSecurityChange("twoFactor", e.target.checked)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="setting-item">
              <div className="setting-info">
                <h3>Session Timeout</h3>
                <p>Set how long before you're automatically logged out</p>
              </div>
              <select
                className="form-control"
                value={settings.security.sessionTimeout}
                onChange={(e) => handleSecurityChange("sessionTimeout", e.target.value)}
              >
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="60">1 hour</option>
                <option value="120">2 hours</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Settings 